// import { IGetComplaintById } from "../../utils/types";
import { IGetComplaintById } from "../../utils/types";
import { apiManager } from "../api-manager";

export const getComplaintById = async (id: string) => {
  const res = await apiManager.get<IGetComplaintById>(`/admin/complaint/${id}`);
  return res;
};
